/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class JiraServiceManagementIncidentManagementConfigurationMappingForPolicyViolation extends models.JiraServiceManagementIncidentManagementConfigurationMapping {
    getFixupPrototypeFunction() { return JiraServiceManagementIncidentManagementConfigurationMappingForPolicyViolation.fixupPrototype; }

    static newInstance(model: Partial<JiraServiceManagementIncidentManagementConfigurationMappingForPolicyViolation>): JiraServiceManagementIncidentManagementConfigurationMappingForPolicyViolation {
        let obj = Object.assign(new JiraServiceManagementIncidentManagementConfigurationMappingForPolicyViolation(), model);
        JiraServiceManagementIncidentManagementConfigurationMappingForPolicyViolation.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<JiraServiceManagementIncidentManagementConfigurationMappingForPolicyViolation>): JiraServiceManagementIncidentManagementConfigurationMappingForPolicyViolation {
        if (!model) return null;
        return JiraServiceManagementIncidentManagementConfigurationMappingForPolicyViolation.newInstance(<JiraServiceManagementIncidentManagementConfigurationMappingForPolicyViolation> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: JiraServiceManagementIncidentManagementConfigurationMappingForPolicyViolation) {
        if (!obj) return;

        models.JiraServiceManagementIncidentManagementConfigurationMappingForPolicyViolation.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: JiraServiceManagementIncidentManagementConfigurationMappingForPolicyViolation): boolean {
        if (models.JiraServiceManagementIncidentManagementConfigurationMapping.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, JiraServiceManagementIncidentManagementConfigurationMappingForPolicyViolation.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Allowed attributes for Policy Description
     */
    value: models.DescriptionAttributeForItsmPolicy;

    value_direct: string;

}
